/* eslint-disable import/no-unresolved */
import BaseElement from 'base-element'
import { css, html } from 'lit-all'
import styles from 'lib-styles'
/* eslint-disable import/no-unresolved */

const hiddenTypes = [
  'personalization-fee',
  'gift-box',
  'gift-product',
  'carter-everywhere-mug-personalizations',
  'carter-move-mug-with-360-sip-lid-personalized',
  'carter-move-mug-personalizations',
]

class HHProductRecommendations extends BaseElement {
  static properties = {
    productId: {
      type: Number,
      attribute: 'product-id',
    },
  }

  render() {
    return html``
  }

  static styles = [
    styles.reset,
    styles.a11y,
    styles.flex,
    styles.typography,
    styles.skeleton,
    styles.color,
    styles.animation,
    css``,
  ]
}

customElements.define('hh-product-recommendations', HHProductRecommendations)
